var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.distributors},on:{"click:row":_vm.edit}}),(_vm.loading)?_c('div',[_c('v-progress-linear',{attrs:{"color":"grey","indeterminate":"","height":"12"}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }